import { useState } from 'react'
import SEO from '../components/SEO/SEO'
import Layout from '../layout/Layout'
import classes from '../styles/section.module.css'
import PopUpNotification from '../components/Notification/PopUpNotification'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import PreAuthRequestLookup from '../components/PreAuth/RequestLookup'
import { BASE_URL } from '../constants'
import { getRecaptchaV3Token } from '../utils/recaptcha'
import RecaptchaModal from '../components/Recaptcha/RecaptchaModal'
import useRecaptchaLoader from '../hooks/useRecaptchaLoader'

const PreAuthorization = () => {
  useRecaptchaLoader()
  const [open, setOpen] = useState(false)
  const [isPreAuthModalShown, setIsPreAuthModalShown] = useState(false)
  const [isUploadFileModalShown, setisUploadFileModalShown] = useState(false)
  const [fileUploadResponse, setFileUploadResponse] = useState('success')
  const [fileUploadText, setFileUploadText] = useState('Choose a file')
  const [file, setFile] = useState(null)
  const [showCheckbox, setShowCheckbox] = useState(false)
  const [pendingFile, setPendingFile] = useState(null)

  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))

  const successfulSubmission = () => {
    setFileUploadResponse('success')
    setisUploadFileModalShown(true)
    setFileUploadText('Submitted!')
    setFile(null)
    setTimeout(() => setisUploadFileModalShown(false), 8000)
  }

  const failedSubmission = () => {
    setFileUploadResponse('Failed Please Try again')
    setisUploadFileModalShown(true)
    setFileUploadText('Select a File')
    setTimeout(() => setisUploadFileModalShown(false), 8000)
  }

  const setFiles = event => {
    setFileUploadText(event.target.files[0]?.name?.slice(0, 15) + '...')
    setFile(event.target.files[0])
  }

  const submitFile = async e => {
    e.preventDefault()
    if (file) {
      setFileUploadText('Uploading...')
      let token
      try {
        token = await getRecaptchaV3Token('upload_files')
      } catch (err) {
        setFileUploadText('Select a File')
        await reportError(err)
        return
      }

  const formData = new FormData()
  formData.append('files', file)
  formData.append('captcha_token.token', token)
  formData.append('captcha_token.version', 'v3')
  formData.append('captcha_token.provider', '1')

      const response = await fetch(`${BASE_URL}/Marketing/AuthorizationRequest`, {
        method: 'POST',
        body: formData,
      })

      if (response.status >= 200 && response.status <= 299) {
        successfulSubmission()
      } else if (response.status === 400) {
        // require v2 checkbox fallback
        setPendingFile(file)
        setFileUploadText('Select a File')
        setShowCheckbox(true)
      } else {
        failedSubmission()
      }
    } else {
      document.getElementById('preAuthRequestFormFileUpload').click()
    }

    setFile(null)
  }

  const faqs = [
    {
      question: "What's the best thing about Switzerland?",
      answer:
        "I don't know, but the flag is a big plus. Lorem ipsum dolor sit amet consectetur adipisicing elit. <br /> Quas cupiditate laboriosam fugiat.",
    },
  ]

  const closePreAuthModal = () => {
    setIsPreAuthModalShown(false)
  }

  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

  return (
    <>
      <SEO />
      <Layout>
        <PopUpNotification
          isShown={isUploadFileModalShown}
          fileUploadText={fileUploadText}
          uploadResponse={fileUploadResponse}
        />

        <div className="relative">
          {isPreAuthModalShown && (
            <PreAuthRequestLookup
              isShown={isPreAuthModalShown}
              closeModal={closePreAuthModal}
              successfulSubmission={successfulSubmission}
              failedSubmission={failedSubmission}
            />
          )}
          <div className="absolute inset-x-0 bottom-0 bg-gray-100 h-1/2" />
          <div className="mx-auto">
            <div className="relative">
              <div className="absolute inset-0">
                <img
                  className="object-cover w-full h-full"
                  src="videocallAtDesk.png"
                  alt="People working on laptops"
                />
              </div>
              <div className="relative max-w-screen-xl px-4 py-16 mx-auto md:py-16 lg:py-32">
                <h1 className="text-3xl tracking-tight md:text-5xl text-darkBlue">
                  Provider resources for <br />{' '}
                  <span className="text-globeGreen">
                    prior authorization and more
                  </span>
                </h1>
              </div>
            </div>
          </div>
        </div>

        <section>
          <div className="max-w-screen-xl px-4 py-12 mx-auto sm:px-6 lg:px-8">
            <div className="grid grid-cols-12 gap-8">
              <div className="col-span-12 md:col-span-4">
                <div className="flex flex-col justify-between h-full p-12 bg-blue-dark">
                  <h2 className="text-3xl text-white">
                    Is Prior Authorization <br />
                    Needed?
                  </h2>
                  <button
                    className="inline-block px-4 py-2 mt-8 text-xl text-white bg-transparent border-2 border-white-light hover:bg-white-light hover:text-blue-dark w-fit"
                    onClick={() => window.open('/prior-auth-tool', '_self')}
                  >
                    Prior Auth Tool
                  </button>
                </div>
              </div>
              <div className="col-span-12 md:col-span-4">
                <div className="flex flex-col justify-between h-full p-12 bg-blue">
                  <h2 className="text-3xl text-white">
                    Download the <br />
                    Evry Health <br />
                    Prior authorization <br />
                    Request Form
                  </h2>
                  <a href="https://api.evryhealth.com/api/v1/Marketing/GetFileContent?id=fe65c691-b5ad-4f36-b433-924eb7257eec">
                    <button className="inline-block px-4 py-2 mt-8 text-xl text-white bg-transparent border-2 border-white-light hover:bg-white-light hover:text-blue-dark">
                      Download
                    </button>
                  </a>
                </div>
              </div>
              <div className="col-span-12 md:col-span-4">
                <div className="flex flex-col justify-between h-full p-12 bg-green">
                  <h2 className="text-3xl text-white">
                    Upload Evry Health <br />
                    Prior authorization <br />
                    Request Form with Supporting Clinical Documentation
                  </h2>
                  <button
                    type="submit"
                    className="inline-block px-4 py-2 mt-8 text-xl text-white bg-transparent border-2 border-white-light hover:bg-white-light hover:text-green w-fit"
                    onClick={() => setIsPreAuthModalShown(true)}
                  >
                    Upload
                  </button>
                </div>
              </div>
              <div className="col-span-12 md:col-span-4">
                <div className="flex flex-col justify-between h-full p-12 bg-green">
                  <h2 className="text-3xl text-white">
                    For Searchable Formulary And Rx Prior authorization List
                  </h2>
                  <a
                    href="https://prime.adaptiverx.com/webSearch/index?key=cnhmbGV4LnBsYW4uUGxhblBkZlR5cGUtODA5"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="inline-block px-4 py-2 mt-8 text-xl text-white bg-transparent border-2 border-white-light hover:bg-white-light hover:text-green">
                      Get Started
                    </button>
                  </a>
                </div>
              </div>

              <div className="col-span-12 md:col-span-4">
                <div className="flex flex-col justify-between h-full p-12 bg-blue-dark">
                  <h2 className="text-3xl text-white">
                    Search Our <br />
                    Directory for <br />
                    In-network Providers
                    <br />
                    and Facilities
                  </h2>
                  <a
                    href="https://providers.evryhealth.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="inline-block px-4 py-2 mt-16 text-xl text-white bg-transparent border-2 border-white-light hover:bg-white-light hover:text-blue-dark">
                      Search
                    </button>
                  </a>
                </div>
              </div>
              <div className="col-span-12 md:col-span-4">
                <div className="flex flex-col justify-between h-full p-12 bg-blue">
                  <h2 className="text-3xl text-white">
                    Find more helpful resources on the Texas Department of
                    Insurance's website
                  </h2>
                  <a
                    href="https://www.tdi.texas.gov/hprovider/index.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="inline-block px-4 py-2 mt-16 text-xl text-white bg-transparent border-2 border-white-light hover:bg-white-light hover:text-blue-dark">
                      Visit Website
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        {showCheckbox && (
          <div style={{ position: 'fixed', inset: 0, zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ background: 'rgba(0,0,0,0.5)', position: 'absolute', inset: 0 }} />
            <div style={{ zIndex: 10000, background: '#fff', padding: 20, borderRadius: 8 }}>
              <p style={{ marginBottom: 10 }}>Please complete the verification to continue</p>
    <RecaptchaModal onVerify={async token => {
          const pending = pendingFile
          if (!pending) return
          const formData = new FormData()
          formData.append('files', pending)
          formData.append('captcha_token.token', token)
          formData.append('captcha_token.version', 'v2')
          formData.append('captcha_token.provider', '1')
          const response = await fetch(`${BASE_URL}/Marketing/AuthorizationRequest`, { method: 'POST', body: formData })
          if (response.status >= 200 && response.status <= 299) successfulSubmission()
          else failedSubmission()
          setPendingFile(null)
          setShowCheckbox(false)
      }} onError={() => { setShowCheckbox(false); failedSubmission() }} onClose={() => setShowCheckbox(false)} />
              <div style={{ marginTop: 8, textAlign: 'right' }}>
                <button type="button" className="px-4 py-2 text-sm" onClick={() => { setShowCheckbox(false) }}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </Layout>
    </>
  )
}

export default PreAuthorization
